import React from "react";
import { Container } from "react-bootstrap";
import ImageViewerCard from "../../../ImageViewerCard";
import "../../../incidentes.css";

const ImagenProcesoMarketing = () => {
  const imagenUrl = `${process.env.REACT_APP_BUCKET}/img/marketing-proceso-imagen.jpg`;
  /*const imagenUrl = "/img/marketing-proceso-imagen.jpg";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Solicitud de Material de Marketing</h1>
        </div>
        <ImageViewerCard
          imagenUrl={imagenUrl}
          titulo="Solicitud de Material de Marketing"
        />
      </Container>
    </>
  );
};

export default ImagenProcesoMarketing;
